(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-epstein"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // =============================================
  // COUNTDOWN TIMER
  // =============================================
  function initCountdown() {
    // Obtener o establecer fecha de expiración en localStorage
    var storageKey = 'ep_countdown_end';
    var endTime = localStorage.getItem(storageKey);
    var now = new Date().getTime();

    if (!endTime || parseInt(endTime) < now) {
      // Establecer countdown de 6 horas desde ahora
      endTime = now + (6 * 60 * 60 * 1000);
      localStorage.setItem(storageKey, endTime.toString());
    } else {
      endTime = parseInt(endTime);
    }

    function updateCountdown() {
      var currentTime = new Date().getTime();
      var distance = endTime - currentTime;

      if (distance < 0) {
        // Reset el timer cuando llega a 0
        endTime = currentTime + (6 * 60 * 60 * 1000);
        localStorage.setItem(storageKey, endTime.toString());
        distance = endTime - currentTime;
      }

      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var elHours = document.getElementById('ep-hours');
      var elMinutes = document.getElementById('ep-minutes');
      var elSeconds = document.getElementById('ep-seconds');
      var elHeroH = document.getElementById('ep-hero-h');
      var elHeroM = document.getElementById('ep-hero-m');
      var elHeroS = document.getElementById('ep-hero-s');

      var hStr = hours < 10 ? '0' + hours : '' + hours;
      var mStr = minutes < 10 ? '0' + minutes : '' + minutes;
      var sStr = seconds < 10 ? '0' + seconds : '' + seconds;

      if (elHours) elHours.textContent = hStr;
      if (elMinutes) elMinutes.textContent = mStr;
      if (elSeconds) elSeconds.textContent = sStr;
      if (elHeroH) elHeroH.textContent = hStr;
      if (elHeroM) elHeroM.textContent = mStr;
      if (elHeroS) elHeroS.textContent = sStr;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // =============================================
  // STOCK COUNTER (Decremental aleatorio)
  // =============================================
  function initStockCounter() {
    var storageKey = 'ep_stock_count';
    var stock = localStorage.getItem(storageKey);

    if (!stock) {
      stock = 147;
    } else {
      stock = parseInt(stock);
    }

    // Decrementar aleatoriamente cada 30-90 segundos
    function decrementStock() {
      if (stock > 12) {
        stock -= Math.floor(Math.random() * 2) + 1;
        localStorage.setItem(storageKey, stock.toString());
      }

      var elements = document.querySelectorAll('#ep-stock-count, #ep-stock-final');
      elements.forEach(function(el) {
        el.textContent = stock;
      });

      var nextDecrement = (Math.floor(Math.random() * 60) + 30) * 1000;
      setTimeout(decrementStock, nextDecrement);
    }

    // Inicializar valores
    var elements = document.querySelectorAll('#ep-stock-count, #ep-stock-final');
    elements.forEach(function(el) {
      el.textContent = stock;
    });

    setTimeout(decrementStock, 45000);
  }

  // =============================================
  // VIEWERS COUNTER (Fluctuante)
  // =============================================
  function initViewers() {
    var viewerEl = document.getElementById('ep-viewers');
    if (!viewerEl) return;

    function updateViewers() {
      var base = 28;
      var variation = Math.floor(Math.random() * 25);
      viewerEl.textContent = base + variation;
    }

    updateViewers();
    setInterval(updateViewers, 8000);
  }

  // =============================================
  // LAST PURCHASE NOTIFICATION
  // =============================================
  function initLastPurchase() {
    var timeEl = document.getElementById('ep-last-purchase');
    var cityEl = document.getElementById('ep-last-city');
    if (!timeEl || !cityEl) return;

    var cities = [
      'Santiago', 'Viña del Mar', 'Concepción', 'La Serena',
      'Antofagasta', 'Temuco', 'Rancagua', 'Iquique', 'Talca',
      'Valparaíso', 'Puerto Montt', 'Chillán', 'Valdivia', 'Osorno',
      'Copiapó', 'Punta Arenas', 'Arica', 'Los Ángeles', 'Coquimbo'
    ];

    function updatePurchase() {
      var minutes = Math.floor(Math.random() * 12) + 1;
      var city = cities[Math.floor(Math.random() * cities.length)];
      timeEl.textContent = minutes;
      cityEl.textContent = city;
    }

    updatePurchase();
    setInterval(updatePurchase, 30000);
  }

  // =============================================
  // SOCIAL PROOF NOTIFICATION POPUP
  // =============================================
  function initNotifications() {
    var notification = document.getElementById('ep-notification');
    var nameEl = document.getElementById('ep-notif-name');
    var timeEl = document.getElementById('ep-notif-time');
    if (!notification || !nameEl || !timeEl) return;

    var buyers = [
      { name: 'Javiera', city: 'Santiago' },
      { name: 'Tomás', city: 'Viña del Mar' },
      { name: 'Catalina', city: 'Concepción' },
      { name: 'Benjamín', city: 'La Serena' },
      { name: 'Antonia', city: 'Antofagasta' },
      { name: 'Diego', city: 'Temuco' },
      { name: 'Sofía', city: 'Rancagua' },
      { name: 'Matías', city: 'Iquique' },
      { name: 'Valentina', city: 'Valparaíso' },
      { name: 'Lucas', city: 'Puerto Montt' },
      { name: 'Ignacia', city: 'Chillán' },
      { name: 'Vicente', city: 'Valdivia' },
      { name: 'Isidora', city: 'Osorno' },
      { name: 'Joaquín', city: 'Copiapó' },
      { name: 'Florencia', city: 'Punta Arenas' }
    ];

    var times = [
      'Hace 1 minuto', 'Hace 2 minutos', 'Hace 3 minutos',
      'Hace 5 minutos', 'Hace 8 minutos', 'Hace 12 minutos'
    ];

    function showNotification() {
      var buyer = buyers[Math.floor(Math.random() * buyers.length)];
      var time = times[Math.floor(Math.random() * times.length)];

      nameEl.textContent = buyer.name + ' de ' + buyer.city;
      timeEl.textContent = time;

      notification.classList.add('ep-show');

      setTimeout(function() {
        notification.classList.remove('ep-show');
      }, 5000);
    }

    // Primera notificación a los 15 segundos
    setTimeout(function() {
      showNotification();
      // Luego cada 25-45 segundos
      setInterval(showNotification, (Math.floor(Math.random() * 20) + 25) * 1000);
    }, 15000);
  }

  // =============================================
  // STICKY MOBILE CTA - SHOW/HIDE ON SCROLL
  // =============================================
  function initStickyMobile() {
    var sticky = document.getElementById('ep-sticky-cta');
    if (!sticky) return;

    var lastScroll = 0;
    var heroHeight = 600;

    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;

      if (currentScroll > heroHeight) {
        sticky.style.display = 'block';
        sticky.style.animation = 'ep-slide-up 0.3s ease forwards';
      } else {
        sticky.style.display = 'none';
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // =============================================
  // SMOOTH SCROLL PARA CTAs
  // =============================================
  function initSmoothScroll() {
    var ctaButtons = document.querySelectorAll('.ep-cta-btn[href="#"]');
    ctaButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        // Si href es # scrollea a bundles, si no deja el comportamiento normal
        if (this.getAttribute('href') === '#') {
          e.preventDefault();
          var bundlesSection = document.querySelector('.ep-bundles');
          if (bundlesSection) {
            bundlesSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  }

  // =============================================
  // EXIT INTENT POPUP (Desktop only)
  // =============================================
  function initExitIntent() {
    var shown = false;

    document.addEventListener('mouseout', function(e) {
      if (shown) return;
      if (e.clientY < 5) {
        shown = true;
        // Crear popup overlay
        var overlay = document.createElement('div');
        overlay.id = 'ep-exit-overlay';
        overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.85);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;animation:ep-fade-in 0.3s ease;';

        var popup = document.createElement('div');
        popup.style.cssText = 'background:#ffffff;border:2px solid #9059ff;border-radius:16px;padding:48px 40px;max-width:500px;width:100%;text-align:center;position:relative;color:#121212;font-family:Helvetica Neue,Arial,sans-serif;box-shadow:0 20px 50px rgba(0,0,0,0.15);';

        popup.innerHTML = '' +
          '<button onclick="document.getElementById(\'ep-exit-overlay\').remove()" style="position:absolute;top:16px;right:20px;background:none;border:none;color:#666;font-size:28px;cursor:pointer;line-height:1;">×</button>' +
          '<div style="font-size:48px;margin-bottom:16px;">⚠️</div>' +
          '<h3 style="font-size:26px;font-weight:900;margin-bottom:12px;line-height:1.2;color:#121212;">¡ESPERA!</h3>' +
          '<p style="font-size:16px;color:#4b4b4b;margin-bottom:8px;">¿De verdad te vas sin el tuyo?</p>' +
          '<p style="font-size:22px;font-weight:800;color:#9059ff;margin-bottom:24px;">10% EXTRA DE DESCUENTO</p>' +
          '<p style="font-size:14px;color:#666;margin-bottom:20px;">Usa el código en el checkout:</p>' +
          '<div style="background:#f9f9f9;border:2px dashed #9059ff;border-radius:8px;padding:16px;font-size:28px;font-weight:900;letter-spacing:6px;margin-bottom:24px;color:#121212;">CODE10</div>' +
          '<a href="#" onclick="document.getElementById(\'ep-exit-overlay\').remove();document.querySelector(\'.ep-bundles\').scrollIntoView({behavior:\'smooth\'});return false;" style="display:block;background:#9059ff;color:white;padding:16px 32px;border-radius:8px;font-size:15px;font-weight:800;text-transform:uppercase;letter-spacing:1.5px;text-decoration:none;">APLICAR DESCUENTO Y COMPRAR</a>' +
          '<p onclick="document.getElementById(\'ep-exit-overlay\').remove()" style="margin-top:16px;font-size:12px;color:#666;cursor:pointer;text-decoration:underline;">No gracias, prefiero pagar precio completo</p>';

        overlay.appendChild(popup);
        document.body.appendChild(overlay);
      }
    });
  }

  // =============================================
  // SCROLL ANIMATIONS (Fade in on scroll)
  // =============================================
  function initScrollAnimations() {
    var style = document.createElement('style');
    style.textContent = '' +
      '.ep-animate-in { opacity: 0; transform: translateY(30px); transition: opacity 0.6s ease, transform 0.6s ease; }' +
      '.ep-animate-in.ep-visible { opacity: 1; transform: translateY(0); }' +
      '@keyframes ep-slide-up { from { transform: translateY(100%); } to { transform: translateY(0); } }' +
      '@keyframes ep-fade-in { from { opacity: 0; } to { opacity: 1; } }';
    document.head.appendChild(style);

    // Agregar clase a elementos animables
    var animatables = [
      '.ep-detail-card',
      '.ep-benefit-card',
      '.ep-testimonial-card',
      '.ep-bundle-card',
      '.ep-faq-item',
      '.ep-gal-item'
    ];

    animatables.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        el.classList.add('ep-animate-in');
      });
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ep-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.ep-animate-in').forEach(function(el) {
      observer.observe(el);
    });
  }

  // =============================================
  // ADD TO CART TRACKING (Analytics Events)
  // =============================================
  function initTracking() {
    var allCTAs = document.querySelectorAll('.ep-cta-btn, .ep-bundle-cta');
    allCTAs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Google Analytics 4 Event
        if (typeof gtag === 'function') {
          gtag('event', 'add_to_cart', {
            event_category: 'ecommerce',
            event_label: 'epstein_hoodie',
            value: 19890,
            currency: 'CLP'
          });
        }

        // Facebook Pixel Event
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_name: 'Poleron Epstein',
            content_type: 'product',
            value: 19890,
            currency: 'CLP'
          });
        }

        // TikTok Pixel Event
        if (typeof ttq === 'object') {
          ttq.track('AddToCart', {
            content_id: 'epstein_hoodie',
            content_type: 'product',
            value: 19890,
            currency: 'CLP'
          });
        }
      });
    });

    // Track page view
    if (typeof fbq === 'function') {
      fbq('track', 'ViewContent', {
        content_name: 'Landing Poleron Epstein',
        content_type: 'product',
        value: 19890,
        currency: 'CLP'
      });
    }
  }

  // =============================================
  // TALLA SELECTOR (Opcional - Inline)
  // =============================================
  function initSizeSelector() {
    var sizeContainers = document.querySelectorAll('.ep-size-selector');
    sizeContainers.forEach(function(container) {
      var buttons = container.querySelectorAll('.ep-size-btn');
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          // Highlight active
          buttons.forEach(function(b) { b.classList.remove('ep-size-active'); });
          this.classList.add('ep-size-active');

          // Update variant in all forms
          var selectedSize = this.getAttribute('data-size');
          var variantInputs = document.querySelectorAll('input[name="id"]');
          var productData = null;
          try {
            var productJsonEl = document.querySelector('[data-product-json]');
            if (productJsonEl) productData = JSON.parse(productJsonEl.textContent);
          } catch(e) {}

          if (productData && productData.variants) {
            var matchedVariant = productData.variants.find(function(v) {
              return v.title === selectedSize || v.option1 === selectedSize;
            });
            if (matchedVariant) {
              variantInputs.forEach(function(input) {
                input.value = matchedVariant.id;
              });
            }
          }
        });
      });
    });
  }

  // =============================================
  // INICIALIZAR TODO CUANDO EL DOM ESTÉ LISTO
  // =============================================
  function init() {
    initCountdown();
    initStockCounter();
    initViewers();
    initLastPurchase();
    initNotifications();
    initStickyMobile();
    initSmoothScroll();
    initExitIntent();
    initScrollAnimations();
    initTracking();
    initSizeSelector();
  }

  // Ejecutar cuando DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

  } catch(e) { console.error(e); }
})();
})();
